import React, { Component } from 'react';
import Headers from '../Headers';
import Tables from '../Tables';
import Singleton from '../../sock';
import DisplayError from '../../DisplayError';
import fetchBookNo from '../fetchCode';
import {ToastContainer} from 'react-toastr';

var booknos = [];
const theaders = ['Book', 'Title', 'Branch Name', 'Target Branch', 'Book Status', 'Ibt Status','Owner Branch'];

const mHeaders = ['number', 'titleName', 'branchId', 'requestedBranchId', 'status', 'ibtStatus','origLocationBranchId'];//edit it according to json data
class Dispatch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            bookno: '',
            tdata: {},
            reset: false,
            dataToPrint: {},
            errorVisible: false,
            errorDesc: {}
        }
        this.fetchCode = this.fetchCode.bind(this);
        this.handlePrintClick = this.handlePrintClick.bind(this);
    }

    handlePrintClick(divData){
        console.log(this.input1.value);
        
        var printContents = document.getElementById("printMe").innerHTML;
        
        var w= window.open();
        w.document.write(printContents);
        w.print();
        w.close();
    }

    componentWillMount() {
        this.sock = Singleton.getInstance();
        console.log(this.sock);
    }

    componentDidMount() {
        this.sock.onmessage = (msg) => {
            if (typeof (msg.data) === 'string') {
                this.fetchCode(msg.data);
            }
            else {
                FileReader.prototype.that = this;
                var reader = new FileReader();
                reader.onload = function () {
                    console.log(reader.result)

                    reader.__proto__.that.fetchCode(reader.result)
                }
                reader.readAsText(msg.data)

            }
        }

        this.sock.onerror = (err) => {
            console.log(err);
            this.refs.container.error("Could not connect to ThingMagic. Please check your connection and refresh");
            
        }
    }

    fetchCode(value) {
        var obj = {
            value: value,
            bookno: booknos,
            start: true,
            callingFrom: "dispatch"
        };
        fetchBookNo(obj).then(res => {
            console.log(res);
            if (res.error) {
                this.refs.container.error(res.data)
                // this.setState({
                //     errorDesc: res.data,
                //     errorVisible: res.error
                // });
            }
            else {
                if(res.apiResponse){
                    var { book, ibt } = res.apiResponse
                    res.data.ibtStatus = ibt.status

                    var today = new Date();
                    var dd = today.getDate();
                    var mm = today.getMonth() + 1; //January is 0!
                    var yyyy = today.getFullYear();
    
                    if (dd < 10) {
                        dd = '0' + dd
                    }
    
                    if (mm < 10) {
                        mm = '0' + mm
                    }
    
                    today = dd  + '-' + mm + '-' + yyyy;
                    let dataToPrint = {
                        "Book number" : book.number,
                        "Title" : book.titleName,
                        "Member card" : ibt.memberShipNo,
                        "Requesting branch" : ibt.requestedBranch.id + '-' + ibt.requestedBranch.branchName,
                        "Dispatch date" : today,
                        "Original branch" : ibt.respondantBranch.id + '-' + ibt.respondantBranch.branchName,
                        "Order Id ": ibt.ibtId,
                        "Member branch" : ibt.memberBranch.id + '-' + ibt.memberBranch.branchName,
                        "Request type" : ibt.bookReqType
                    }
                    
                    this.setState({ errorVisible: res.error, tData: res.data, dataToPrint:dataToPrint })
                }else{
                    this.refs.container.error('There is no ibt order associated with this book')
                }
                
            }
            booknos = res.bookno;
        }).catch(err => {
            console.log(err);
            return;
        });

    }

    componentWillUnmount() {
        booknos = [];
        Singleton.closeSocket(this.sock);
    }

    render() {
        return (
            <div>
                <Headers hname="Dispatch" />
                <ToastContainer
                    ref="container"
                    className="toast-top-right"
                />
                <DisplayError
                    errorVisible={this.state.errorVisible}
                    errorDesc={this.state.errorDesc}
                />
                <div>
                    <Tables headers={theaders} mHeaders={mHeaders}
                        body={this.state.tData} myStyle={{ marginTop: 30 }} />
                </div>
                
                {Object.keys(this.state.dataToPrint).length > 0 ? 
                   <div> 
                       <div id = "printMe" ref = {(input) => {this.input1 = input}}style = {{textAlign:"center"}}>
                        {Object.keys(this.state.dataToPrint).map(key =>{
                            return <small>{key}: {this.state.dataToPrint[key]}<br/></small>  })}
                        </div>
                            <div style = {{textAlign:"center"}}><button onClick = {this.handlePrintClick}>Print</button></div>
                        </div>
                        :''}
            </div>
        )
    }
}
export default Dispatch;


// WEBPACK FOOTER //
// ./src/Components/Dispatch/Dispatch.js